import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import { useState, useEffect } from "react";
import { LicenseplateFormCard } from "./components/licenseplate-form-card";
import { LicenseplateResultCard } from "./components/licenseplate-result-card";
// Shared state manager using closure
function createStateManager() {
    var listeners = [];
    var state = null;
    return {
        subscribe: function (listener) {
            listeners.push(listener);
            // Immediately notify with current state
            listener(state);
            return function () {
                listeners = listeners.filter(function (l) { return l !== listener; });
            };
        },
        setState: function (newState) {
            state = newState;
            listeners.forEach(function (listener) { return listener(newState); });
        },
        getState: function () {
            return state;
        },
    };
}
var stateManager = createStateManager();
// Helper to determine the base URL of the script itself
function getScriptBaseUrl() {
    if (document.currentScript instanceof HTMLScriptElement &&
        document.currentScript.src) {
        var url = new URL(document.currentScript.src);
        return url.origin; // e.g., "https://kentekencheck-denhaag.nl"
    }
    return "";
}
// Determine the API base URL once at load time
var baseUrl = getScriptBaseUrl();
// Add Umami
if (!window.umami) {
    var el = document.createElement("script");
    el.setAttribute("src", "https://analytics.savvy.codes/script.js");
    el.setAttribute("data-website-id", "b16e55f9-3b05-48d7-bfbf-049ca1883c11");
    el.defer = true;
    document.body.appendChild(el);
}
function FormApp() {
    var _a = useState(null), response = _a[0], setResponse = _a[1];
    useEffect(function () {
        var unsubscribe = stateManager.subscribe(setResponse);
        return unsubscribe;
    }, []);
    var handleSetResponse = function (newResponse) {
        stateManager.setState(newResponse);
    };
    return (_jsx(LicenseplateFormCard, { baseUrl: baseUrl, response: response, setResponse: handleSetResponse }));
}
function ResultApp() {
    var _a = useState(null), response = _a[0], setResponse = _a[1];
    useEffect(function () {
        var unsubscribe = stateManager.subscribe(setResponse);
        return unsubscribe;
    }, []);
    return _jsx(LicenseplateResultCard, { response: response });
}
window.addEventListener("DOMContentLoaded", function () {
    var licenceplateCheckers = document.querySelectorAll("[data-zes-kentekenchecker], .zes-kentekenchecker");
    var licenceplateResults = document.querySelectorAll("[data-zes-kentekenresult], .zes-kentekenresult");
    licenceplateCheckers.forEach(function (el) {
        var root = createRoot(el);
        root.render(_jsx(FormApp, {}));
    });
    licenceplateResults.forEach(function (el) {
        var root = createRoot(el);
        root.render(_jsx(ResultApp, {}));
    });
});
